var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"rounded-t-lg text-white"},[_c('analysis-component'),_vm._v(" "),_c('link-component')],1)}
var staticRenderFns = []
export { render, staticRenderFns }